"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _polished = require("polished");

var _colors = _interopRequireDefault(require("./colors"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getColor(opacity) {
  return (0, _polished.rgba)(_colors["default"].secondary.main, opacity);
}

var none = 'none';
var up = {
  xs: "0 0 1px 0 ".concat(getColor(0.08), ",0 -0.5px 2px 0 ").concat(getColor(0.12)),
  s: "0 0 1px 0 ".concat(getColor(0.04), ",0 -2px 4px 0 ").concat(getColor(0.12)),
  m: "0 0 2px 0 ".concat(getColor(0.04), ",0 -4px 8px 0 ").concat(getColor(0.12)),
  l: "0 -2px 4px 0 ".concat(getColor(0.04), ",0 -8px 16px 0 ").concat(getColor(0.12)),
  xl: "0 -2px 8px 0 ".concat(getColor(0.04), ",0 -16px 24px 0 ").concat(getColor(0.12)),
  xxl: "0 -2px 8px 0 ".concat(getColor(0.08), ",0 -20px 32px 0 ").concat(getColor(0.16))
};
var down = {
  xs: "0 0 1px 0 ".concat(getColor(0.08), ",0 0.5px 2px 0 ").concat(getColor(0.12)),
  s: "0 0 1px 0 ".concat(getColor(0.04), ",0 2px 4px 0 ").concat(getColor(0.12)),
  m: "0 0 2px 0 ".concat(getColor(0.04), ",0 4px 8px 0 ").concat(getColor(0.12)),
  l: "0 2px 4px 0 ".concat(getColor(0.04), ",0 8px 16px 0 ").concat(getColor(0.12)),
  xl: "0 2px 8px 0 ".concat(getColor(0.04), ",0 16px 24px 0 ").concat(getColor(0.12)),
  xxl: "0 2px 8px 0 ".concat(getColor(0.08), ",0 20px 32px 0 ").concat(getColor(0.16))
};

var _default = _objectSpread({
  none: none,
  up: up,
  down: down
}, down);

exports["default"] = _default;